import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { SeriesIcon } from '../icons/series-icon'
import { TitleIcon } from '../icons/title-icon'
import { RentalIcon } from '../icons/rental-icon'
import { getResponsiveTileShowCount, isContentItemOnMyList } from '../../../../lib/utils'
import { useScreenWidth } from '../../../../hooks/use-screen-width'
import SearchTile from '../search-tile/search-tile'
import EmblaCarousel from '../../../../components/emblaCarousel'
import styles from './search-carousel-with-type.css'

const getCarouselIcon = (type, className) => {
  switch (type) {
    case 'TITLE':
      return <TitleIcon className={className} />
    case 'RENTAL':
      return <RentalIcon className={className} />
    case 'SERIES':
      return <SeriesIcon className={className} />
    default:
      return null
  }
}

/**
 * Component display search result as carousels
 */
const SearchCarouselWithType = ({
  tiles,
  carouselName,
  tilesCount,
  onClickFetchMore,
  type,
  myListItems,
  addToMyList
}) => {
  const iconStyles = classNames(styles.icon)
  const screenWidth = useScreenWidth()
  const slidesToShow = getResponsiveTileShowCount(screenWidth, 2)

  if (!tiles || tiles.length === 0) {
    return null
  }

  return (
    <>
      <div className={styles.carouseTitle}>
        {getCarouselIcon(type, iconStyles)}
        {carouselName}
        (
        {tilesCount}
        )
      </div>

      <EmblaCarousel
        options={{
          // Lower duration makes slide transitions feel faster for search browsing.
          duration: 10
        }}
        slidesToShow={slidesToShow}
        activeSlideCount={tiles.length}
        onClickNext={onClickFetchMore}
      >
        {tiles.map((tile, index) => {
          return (
            <div
              className={styles.emblaSlide}
              key={tile.contentItem.id}
            >
              <SearchTile
                tile={tile}
                index={index}
                listTitle="Search"
                isOnMyList={isContentItemOnMyList(tile.contentItem.id, myListItems)}
                addToMyList={addToMyList}
              />
            </div>
          )
        })}
      </EmblaCarousel>
    </>
  )
}

SearchCarouselWithType.propTypes = {
  tiles: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  carouselName: PropTypes.string.isRequired,
  tilesCount: PropTypes.number,
  type: PropTypes.string.isRequired,
  onClickFetchMore: PropTypes.func,
  addToMyList: PropTypes.func,
  myListItems: PropTypes.array // eslint-disable-line react/forbid-prop-types
}

SearchCarouselWithType.defaultProps = {
  tilesCount: 0,
  onClickFetchMore: undefined,
  addToMyList: undefined,
  myListItems: []
}

export default SearchCarouselWithType
